import { Layouts } from 'react-grid-layout';
import DeleteFileAction from '../../components/Upload/documents-storage/actions/DeleteFileAction';
import DocumentsAction from '../../components/Upload/documents-storage/actions/DocumentsAction';
import DownloadFileAction from '../../components/Upload/documents-storage/actions/DownloadFileAction';
import EditFileDetailsAction from '../../components/Upload/documents-storage/actions/EditFileDetailsAction';
import SimpleFilters from '../../components/Upload/documents-storage/filters/SimpleFilters';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 5,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 32,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 40,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        from_date: null,
        to_date: null,
        filter_options: ['tag_value', 'username', 'uploaded_by', 'file_type'],
    },
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: 'documents',
                    path: '',
                },
                rhsComponents: [
                    {
                        name: 'date-range-picker',
                        props: {
                            defaultPeriod: 'all',
                            visiblePeriods: [
                                '1m',
                                '3m',
                                '6m',
                                '1y',
                                'mtd',
                                'qtd',
                                'ytd',
                                'all',
                            ],
                        },
                    },
                ],
            },
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `documents?`,
                endpointParams: {
                    per_page: '*,per_page',
                    page: '*,page',
                    keyword: 'keyword',
                    from_date: '*,from_date',
                    to_date: '*,to_date',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                    tag_value: 'tag_value',
                    uploaded_by: 'uploaded_by',
                    username: 'username',
                    parent_user_ids: 'parent_user_id,',
                    file_type: 'file_type',
                },
            },
            props: {
                headerText: 'documents',
                requiredQueryFields: [],
                dataKey: 'documents',
                title: '',
                showDownloadOn: ['desktop'],
                canSelectRows: true,
                CustomAction: <DocumentsAction />,
                CustomTableFilter: <SimpleFilters />,
                columns: [
                    {
                        key: 'fileName',
                        otherKeys: ['filePath'],
                        width: 220,
                        type: 'fileName',
                        headerText: 'ui.mm.table-headers.file-name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                        canReorder: false,
                    },
                    {
                        key: 'description',
                        type: 'text',
                        headerText: 'table-headers.description',
                        //selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'filePassword',
                        type: 'text',
                        headerText: 'table-headers.password',
                        //selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'updatedAt',
                        type: 'date',
                        width: 100,
                        headerText: 'table-headers.updated-at',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'createdAt',
                        type: 'date',
                        width: 100,
                        headerText: 'table-headers.created-at',
                        canSort: true,
                    },
                    {
                        key: 'uploadedBy',
                        type: 'text',
                        width: 100,
                        headerText: 'table-headers.uploaded-by',
                    },
                    {
                        key: 'username',
                        type: 'text',
                        headerText: 'table-headers.username',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'transactionTagValue',
                        type: 'tags',
                        headerText: 'ui.mm.table-headers.transaction-tags',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'securityTagValue',
                        type: 'tags',
                        headerText: 'ui.mm.table-headers.security-tags',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'customTagValue',
                        type: 'tags',
                        headerText: 'ui.mm.table-headers.custom-tags',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'fileType',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.file-type',
                    },
                    {
                        key: 'actions',
                        type: 'actions',
                        showOnParentTable: true,
                        actions: [
                            {
                                name: 'download_file',
                                Component: <DownloadFileAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                            {
                                name: 'manage_file_tags',
                                Component: <EditFileDetailsAction />,
                                selectedByDefaultOn: ['desktop', 'tablet'],
                            },
                            {
                                name: 'delete_file',
                                Component: <DeleteFileAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                        ],
                        headerText: 'table-headers.actions',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                        ga_event_name: 'Documents',
                    },
                ],
                per_page: 25,
                filterType: 'simple-filters',
                filterApi: 'filters/documents',
                defaultSelection: '',
                ga_event_name: 'Review All Documents ',
            },
        },
    ],
};
